var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13V7V5C1 2.79086 2.79086 1 5 1H7H13V7V9C13 11.2091 11.2091 13 9 13H7H1Z",
    fill: "#E5EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99997 5.5H9.99997M3.99997 8.5H9.99997M7 1H5C2.79086 1 1 2.79086 1 5V7V13H7H9C11.2091 13 13 11.2091 13 9V7V1H7Z",
    stroke: "#0A255C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.6adb2ce8c7c04db25d2194209d53c511.svg";
export { ForwardRef as ReactComponent };